<style media="screen">
  trumbowyg {
    display: block;
  }
</style>
<div></div>
